Namespace 'Monitoring.Reports.Publications.Subsections'
class Monitoring.Reports.Publications.Subsections.ThematicsReport extends  Backbone.Model

  initialize:(@metricsSerialized)->
    @level = 1

  getPrintableData:()->
    datas = []
    for data in @metricsSerialized
      data_splitted = data.level_1.split('>')
      data_name = data_splitted[data_splitted.length-1]
      plotable = [data_name, data.count]
      datas.push(plotable)
    @getTop5(datas)

  getTop5:(data)->
    sorted_elements = _.sortBy data, (elem) -> elem[1]
    descendent_sorted_elements = sorted_elements.reverse()
    _.first(descendent_sorted_elements, 5) 